module.exports = __webpack_public_path__ + "img/editor.0883554b.svg";